import { Component, OnInit } from '@angular/core';
import { Rol } from 'src/app/models/rol.model';
import { Permission } from 'src/app/models/permission.model';
import { RolesAndPermissionsService } from '../../../../services/roles-and-permissions.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseObject } from 'src/app/models/response-object.model';
import { Department } from 'src/app/models/department.model';
import { PermissionView } from 'src/app/models/permission-view.model';
import { PositionRole } from 'src/app/models/position-role.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-roles-and-permissions',
  templateUrl: './roles-and-permissions.component.html',
  styleUrls: ['./roles-and-permissions.component.scss']
})
export class RolesAndPermissionsComponent implements OnInit {
  inputs = {
    rol: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: '',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    }
  };
  //roles:any;
  focusRol = false;
  timeout = null;
  rolesFilter: any;
  inventoryPermissions: PermissionView[] = [];
  bankPermissions: PermissionView[] = [];
  cxcPermissions: PermissionView[] = [];
  cxpPermissions: PermissionView[] = [];
  billsPermissions: PermissionView[] = [];
  erpPermissions: PermissionView[] = [];
  econtaPermissions: PermissionView[] = [];
  serpReportsPermissions: PermissionView[] = [];
  serpCrudsPermissions: PermissionView[] = [];
  serpRrhhPermissions: PermissionView[] = [];
  serpCashiersPermissions: PermissionView[] = [];
  serpHistoryPermissions: PermissionView[] = [];
  serpConfigPermissions: PermissionView[] = [];
  serpOperationsPermissions: PermissionView[] = [];
  serpGraphicsPermissions: PermissionView[] = [];
  listAllPermissions = [];
  roles: Rol[] = [
    { id: 1, name: 'vendedor' }
  ];
  creating = false;
  departments: Department[] = [];
  permissionsMapping = {
    inventarios_: this.inventoryPermissions,
    bancos_: this.bankPermissions,
    cxc_: this.cxcPermissions,
    cxp_: this.cxpPermissions,
    gastos_: this.billsPermissions,
    erp_admin: this.erpPermissions,
    econta_: this.econtaPermissions,
    serp_reportes: this.serpReportsPermissions,
    serp_cruds: this.serpCrudsPermissions,
    serp_rrhh: this.serpRrhhPermissions,
    serp_cajas: this.serpCashiersPermissions,
    serp_history: this.serpHistoryPermissions,
    serp_config: this.serpConfigPermissions,
    serp_operacion: this.serpOperationsPermissions,
    serp_graficas: this.serpGraphicsPermissions
  };
  allPerms = false;

  constructor(
    private RaS: RolesAndPermissionsService,
    private authService: AuthenticationService,
    private toastr: ToastrService
  ) {

  }

  ngOnInit(): void {
    document.addEventListener('click', this.handleDocumentClick);
    this.getPermissions();
    this.getRoles();
    this.getDepartments();
  }

  changeAllKindOfPerms(permission, value) {
    permission.create = value;
    permission.update = value;
    permission.read = value;
    permission.delete = value;
  }

  selectAllPerms() {
    if (this.allPerms) {
      this.listAllPermissions.forEach((e) => {
        e.permissions.forEach((perm) => {
          this.changeAllKindOfPerms(perm.permission, false);
        });
      });
    } else {
      this.listAllPermissions.forEach((e) => {
        e.permissions.forEach((perm) => {
          if (perm.name?.toLowerCase() !== "Acceder a facturas de mis bodegas".toLowerCase()) {
            this.changeAllKindOfPerms(perm.permission, true);
          } else {
            this.changeAllKindOfPerms(perm.permission, false);
          }
        });
      });
    }
    this.allPerms = !this.allPerms;
  }

  getRoles() {
    this.RaS.getPositions().subscribe({
      next: (response) => {
        this.roles = Object(response)['data'];
        this.rolesFilter = this.roles;
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.message)
      }
    })
  }

  getPermissions() {
    this.RaS.getPermissions(parseInt(this.authService.getCurrentCompanyId())).subscribe(
      {
        next: (response) => {
          const allPermissions = Object(response)['data'];
          for (let i = 0; i < allPermissions.length; i++) {
            const element = allPermissions[i];
            let tempArray;

            // Iterate through the mapping and find the matching prefix
            for (const prefix in this.permissionsMapping) {
              if (element.name.indexOf(prefix) === 0) {
                tempArray = this.permissionsMapping[prefix];
                break;
              }
            }

            if (tempArray) {
              const tempPermission = new PermissionView(element.id, element.displayName);
              const permission = new Permission(element.id);
              tempPermission.permission = permission;
              tempArray.push(tempPermission);
            }
          }
          this.listAllPermissions.push({ permissions: this.serpOperationsPermissions, class: 'operations', placeholder: 'Operaciones', icon: 'fa-gears' });
          this.listAllPermissions.push({ permissions: this.serpReportsPermissions, class: 'serp', placeholder: 'Reportería', icon: 'fa-chart-simple' });
          this.listAllPermissions.push({ permissions: this.serpConfigPermissions, class: 'config', placeholder: 'Configuraciones', icon: 'fa-gears' });
          this.listAllPermissions.push({ permissions: this.serpHistoryPermissions, class: 'history', placeholder: 'Historiales', icon: 'fa-calendar' });
          this.listAllPermissions.push({ permissions: this.serpGraphicsPermissions, class: 'graphics', placeholder: 'Graficas', icon: 'fa-chart-pie' });
        },
        error: (error) => {

        }
      }
    )
  }

  changePermission(type: string, permission: PermissionView) {
    if (permission.name.includes("facturas")){
      var names = ["Acceder a facturas de mis bodegas","Acceder a todas las facturas"];
      var status = permission.name == names[0] ? 1: permission.name == names[1] ? 0 : -1;
      if (status > -1) {
        this.listAllPermissions.forEach((e) => {
          e.permissions.forEach((perm) => {
            if (perm.name?.toLowerCase() === names[status].toLowerCase()) {
              this.changeAllKindOfPerms(perm.permission, false);
            }
          });
        });
      }
    }
    if (type == 'create') {
      permission.permission.create = !permission.permission.create;
    }
    if (type == 'update') {
      permission.permission.update = !permission.permission.update;
    }
    if (type == 'read') {
      permission.permission.read = !permission.permission.read;
    }
    if (type == 'delete') {
      permission.permission.delete = !permission.permission.delete;
    }
    permission.touched = true;
    this.allPerms = this.allPerms ? false : this.allPerms;
  }

  savePermissions() {
    var permissions: Permission[] = [];
    var requestPositionRole = new PositionRole();
    requestPositionRole.position = this.inputs.rol.data.id;
    this.listAllPermissions.forEach((typePermission) => {
      typePermission.permissions.forEach((permission: PermissionView) => {
        if (permission.permission.create || permission.permission.update || permission.permission.delete || permission.permission.read) {
          permissions.push(permission.permission);
        }
      });
    })
    requestPositionRole.permissions = permissions;
    if (this.creating) {
      this.RaS.savePositionRole(requestPositionRole).subscribe({
        next: (response: ResponseObject) => {
          this.toastr.success("Permisos creados correctamente!");
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.message);
        }
      })
    } else {
      this.RaS.updatePositionRole(requestPositionRole).subscribe({
        next: (response: ResponseObject) => {
          this.toastr.success("Cambios guardados correctamente!");
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.message);
        }
      })
    }
  }

  getDepartments() {
    this.RaS.getDepartments().subscribe({
      next: (response: ResponseObject) => {
        this.departments = response.data;
      }
    })
  }

  handleInput(event: any, type: string) {
    this.focusRol = type == 'rol';
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value as any;
    const input = event.target as HTMLInputElement;
    const parentInput = input.parentElement;
    const divElements = parentInput.getElementsByClassName('suggestions')[0];
    divElements.classList.add('suggestions-show');
    if (type == 'rol') {
      /*  */
      clearTimeout(this.timeout);
      this.inputs.rol.class = "typing";
      // Make a new timeout set to go off in 1000ms (1 second)
      this.timeout = setTimeout(() => {
        if (inputValue != '') {
          this.rolesFilter = this.roles.filter((rol) => {
            return rol.id == inputValue || rol.name.toLowerCase().includes(inputValue.toLowerCase())
          });
          if (this.rolesFilter.length == 1) {
            this.changeStatusInput(this.rolesFilter[0], this.rolesFilter[0].name, 1, 'rol');
          } else {
            this.inputs.rol.class = 'fa-user-plus';
            this.changeStatusInput(null, inputValue, 0, 'rol');
          }
        } else {
          this.rolesFilter = this.roles;
          this.changeStatusInput(null, null, 0, 'rol');
        }
      }, 500);
    }
  };

  private handleDocumentClick = (event: Event) => {
    const elements = document.getElementsByClassName('suggestions');
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const inputElement = element.parentElement.querySelectorAll("input")[0];
      if (!(event.target instanceof HTMLElement) || !inputElement.contains(event.target)) {
        element.classList.remove('suggestions-show');
      }
    }
  };

  /**
   * Function that verifies if an input value is empty, correct or erroneous.
   * @param event An event of the input to verify
   * @param type An string, 'warehouse' if the input is for select warehouse or 'client' if the input is for select client
   */
  verifiedInput(event: any, type: string) {
    var inputValue = (event.target as HTMLInputElement).value as any;
    if (inputValue == '') {
      if (type == 'rol') {
        this.changeStatusInput(null, null, 2, 'rol');
      }
    } else {
      switch (type) {
        case 'rol':
          {
            this.rolesFilter = this.roles.filter((rol) => {
              return rol.id == inputValue || rol.name.toLowerCase().includes(inputValue.toLowerCase())
            });
            if (this.rolesFilter.length == 1) {
              this.changeStatusInput(this.rolesFilter[0], this.rolesFilter[0].name, 1, 'rol');
            } else {
              if (inputValue != '') {
                this.inputs.rol.class = 'fa-user-plus';
                this.changeStatusInput(null, inputValue, 0, 'rol');
              } else {
                this.changeStatusInput(null, null, 0, 'rol');
              }
            }
          }
        default:
          break;
      }
    }
  }
  /**
   * Function that shows visually status of the current warehouse/client
   * @param selected An object that represents the selected value, null if the entered value does not match any warehouse/client.
   * @param newValue An string that represents the new value of the input, null if the entered value does not need to be change.
   * @param status An integer, 1 if the selected value is OK, 2 if is blank and 0 if does not mach any warehouse/client
   * @param type An string, that represents if the input is for 'warehouse' or 'client'
   */
  changeStatusInput(selected: any, newValue: string, status: number, type: string) {
    this.creating = false;
    let tempInput;
    if (type == 'rol') {
      tempInput = this.inputs.rol;
    }
    tempInput.verified = status == 1;
    if (status == 1) {
      tempInput.data = selected;
      tempInput.value = newValue;
      tempInput.color = "success";
      tempInput.class = (tempInput.class != 'fa-user-plus') ? 'fa-circle-check' : tempInput.class;
      if (selected) {
        this.resetPermissions();
        tempInput.class = "typing";
        this.RaS.getRolePermissions(selected.id).subscribe({
          next: (response: ResponseObject) => {
            if (response.data.length > 0) {
              this.creating = false;
              response.data.forEach(dbPermission => {
                this.listAllPermissions.forEach((list) => {
                  list.permissions.forEach((permission: PermissionView) => {
                    if (permission.id == dbPermission.roleId) {
                      permission.permission.create = dbPermission.create;
                      permission.permission.update = dbPermission.update;
                      permission.permission.delete = dbPermission.delete;
                      permission.permission.read = dbPermission.read;
                    }
                  });
                })
              });
            } else {
              this.creating = true;
            }
            tempInput.class = "fa-circle-check";
          },
          error: (error) => {
            tempInput.class = "";
            this.creating = true;
            this.toastr.error(error.error.message);
          }
        })
      } else {
        this.creating = true;
      }
    } else {
      tempInput.data = null;
      tempInput.color = 'danger';
      if (status == 0) {
        tempInput.class = 'fa-xmark';
      } else {
        tempInput.class = 'fa-asterisk';
      }
    }
  }

  resetPermissions() {
    this.listAllPermissions.forEach((list) => {
      list.permissions.forEach((permission: PermissionView) => {
        permission.touched = false;
        permission.permission.create = false;
        permission.permission.update = false;
        permission.permission.delete = false;
        permission.permission.read = false;
      });
    })
  }
}
